export const LOCAL_STORAGE_TOKEN_KEY = 'proquinalToken';
export const LOCAL_STORAGE_TOKEN_EXPIRATION_KEY = 'proquinalTokenExpiration';